import { DiscountRulesWidget } from '../components';

export const widgetMapping = {
  widget: {
    discount_rules: DiscountRulesWidget,
  }
};
